/**
 * Remove undefined values from an object recursively.
 * Keeps: null, 0, false, ""
 * Removes: undefined
 * @param {any} obj - The object to clean
 * @returns {any} - The cleaned object
 */
export const stripUndefinedDeep = (obj) => {
    if (obj === null || obj === undefined) {
        return obj; // Let caller handle top-level null/undefined, usually we pass object
    }

    // Handle Arrays
    if (Array.isArray(obj)) {
        return obj
            .map(item => stripUndefinedDeep(item))
            .filter(item => item !== undefined);
    }

    // Handle Objects
    if (typeof obj === 'object') {
        const newObj = {};
        Object.keys(obj).forEach(key => {
            const value = obj[key];
            if (value !== undefined) {
                const cleanedValue = stripUndefinedDeep(value);
                if (cleanedValue !== undefined) {
                    newObj[key] = cleanedValue;
                }
            }
        });
        return newObj;
    }

    // Primitives
    return obj;
};
